(function () {
  if (window.__customCriticalInit) return;
  window.__customCriticalInit = true;

  /* ---------- HEADER / DRAWER EVENTS (DELEGATED) ---------- */
  document.addEventListener("click", function (e) {
    const target = e.target;

    const headerMenuBtn = document.querySelector(
      ".header__icon-list button[aria-controls='header-sidebar-menu']"
    );
    if (!headerMenuBtn) return;

    /* Mobile sticky category button */
    if (target.closest(".mobilesticky-bar-wrap .open_mobilemenu")) {
      e.preventDefault();
      headerMenuBtn.click();
      return;
    }

    /* Drawer close button */
    if (target.closest(".customer-details-wrapper .drawerclosebutton")) {
      headerMenuBtn.click();
      return;
    }

    /* App banner close */
    if (target.closest(".mobileappbutton-block")) {
      const drawerHeader = document.querySelector(".mobile_drawerheader");
      drawerHeader?.classList.add("hidden");
      return;
    }

    /* Submenu toggle */
    const submenuBtn = target.closest(".submenuopen-button");
    if (submenuBtn) {
      submenuBtn.classList.toggle("active");
      submenuBtn
        .closest("li")
        ?.querySelector(".menu")
        ?.classList.toggle("active");
    }
  });
})();
